import { Head, useForm } from '@inertiajs/react'
import { SubmitEvent } from 'react'
import { EventFormData } from '@/types/shared'
import { ManagerEventsEditProps } from '@/types/manager_events'
import EventForm from './_form'

export default function EditEvent({ event, tracks, seasons, paths, errors }: ManagerEventsEditProps) {
  const { data, setData, patch, processing } = useForm<EventFormData>({
    event: {
      name: event.name,
      slug: event.slug,
      date: event.date,
      track_id: event.track_id,
      applications_open_at: event.applications_open_at,
      applications_close_at: event.applications_close_at,
      publish_at: event.publish_at,
      description: event.description,
      price: event.price,
      schedule: event.schedule,
      notes: event.notes,
      parking_override: event.parking_override,
      pit_access_override: event.pit_access_override,
      instagram_hashtag: event.instagram_hashtag,
      social_urls: event.social_urls,
      accepts_drivers: event.accepts_drivers,
      accepts_teams: event.accepts_teams,
      accepts_staff: event.accepts_staff,
      accepts_media: event.accepts_media,
      media_auto_approval_override: event.media_auto_approval_override,
      media_auto_approval_limit_override: event.media_auto_approval_limit_override,
      driver_self_reports_override: event.driver_self_reports_override,
      media_self_reports_override: event.media_self_reports_override,
      poster: null,
      remove_poster: false,
      season_id: '',
    }
  })

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault()
    patch(paths.update)
  }

  return (
    <div className="flex">
      <Head title="Edit Event" />
      <div className="grow">
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
          <EventForm
            data={data}
            setData={setData}
            onSubmit={handleSubmit}
            processing={processing}
            errors={errors}
            tracks={tracks}
            seasons={seasons}
            currentSeasonIds={event.current_season_ids}
            title="Edit Event"
            submitLabel="Save Changes"
            hasPoster={event.has_poster}
            posterUrl={event.poster_url}
          />
        </div>
      </div>
    </div>
  )
}
